(() => {
  "use strict";
  const I = {
    x: '<path d="M7 7l10 10M17 7 7 17"/>',
      target:
        '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1" fill="currentColor"/>',
      curve:
        '<path d="M8 21c-.6-5.5.3-9.6 3-12.3 2-2 4.6-2.6 6-1.3 1.5 1.4.8 3.9-1.3 4.6"/><circle cx="16.6" cy="5.2" r="1.5"/>',
      dual: '<circle cx="9" cy="12" r="5.5"/><circle cx="15" cy="12" r="5.5"/>',
      plug: '<path d="M12 3.5c2.8 3 4 5.6 4 8a4 4 0 0 1-8 0c0-2.4 1.2-5 4-8Z"/><path d="M12 15.5v3.2M7.5 20.5h9"/>',
      spark:
        '<path d="M12 3.5 13.8 9l5.7 1.8-5.7 1.9L12 18.5l-1.8-5.8-5.7-1.9L10.2 9z"/><path d="M19 3v3M17.5 4.5h3"/>',
      waves: '<path d="M3 8c3-2.5 6 2.5 9 0s6 2.5 9 0M3 13c3-2.5 6 2.5 9 0s6 2.5 9 0M3 18c3-2.5 6 2.5 9 0s6 2.5 9 0"/>',
      pin: '<circle cx="12" cy="12" r="2.4" fill="currentColor"/><circle cx="12" cy="12" r="6.5"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5"/>',
      bolt: '<path d="M13 2.5 5 13.5h6l-1 8 8-11h-6z"/>',
      move: '<path d="M12 3v18M8 7l4-4 4 4M8 17l4 4 4-4"/>',
      gift: '<rect x="3.5" y="9" width="17" height="11.5" rx="2"/><path d="M12 9v11.5M3.5 13h17M12 9S9.5 3.5 7.5 5.2C5.8 6.7 8.5 9 12 9Zm0 0s2.5-5.5 4.5-3.8C18.2 6.7 15.5 9 12 9Z"/>',
      seed: '<path d="M12 21v-8"/><path d="M12 13c0-4.5 3-7.5 8-7.5 0 4.5-3 7.5-8 7.5ZM12 15c0-3.5-2.4-6-6.5-6 0 3.5 2.4 6 6.5 6Z"/>',
      heart: '<path d="M12 20.5s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.9c0 5.4-7.5 10-7.5 10Z"/>',
      drawer: '<rect x="3.5" y="4" width="17" height="16" rx="2.5"/><path d="M3.5 12h17M10 8h4M10 16h4"/>',
      solo: '<circle cx="12" cy="8" r="3.8"/><path d="M4.5 20.5c1-4 4-6 7.5-6s6.5 2 7.5 6"/>',
      duo: '<circle cx="8.5" cy="8.5" r="3.2"/><circle cx="16" cy="9.5" r="2.8"/><path d="M2.5 19.5c.8-3.4 3.2-5.2 6-5.2s5.2 1.8 6 5.2M15 14.4c2.8-.3 5.3 1.3 6.3 4.6"/>',
      both: '<circle cx="11" cy="8" r="3.8"/><path d="M3.5 20.5c1-4 4-6 7.5-6s6.5 2 7.5 6"/><path d="M19 3.6c.8-.9 2.4-.4 2.4.9 0 1.4-2.4 2.8-2.4 2.8s-2.4-1.4-2.4-2.8c0-1.3 1.6-1.8 2.4-.9Z"/>',
      small:
        '<rect x="8" y="8" width="8" height="8" rx="2.5"/><path d="M3 9V5a2 2 0 0 1 2-2h4M15 3h4a2 2 0 0 1 2 2v4M21 15v4a2 2 0 0 1-2 2h-4M9 21H5a2 2 0 0 1-2-2v-4"/>',
      easy: '<circle cx="12" cy="12" r="8.5"/><path d="M8.5 12.2 11 14.6l4.8-5"/>',
      drop: '<path d="M12 3.2s6.5 7 6.5 11.3a6.5 6.5 0 0 1-13 0C5.5 10.2 12 3.2 12 3.2Z"/><path d="M9 15a3 3 0 0 0 3 3"/>',
      phone: '<rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/><path d="M10.5 18.5h3"/>',
      chip: '<rect x="6" y="6" width="12" height="12" rx="2.5"/><path d="M9.5 2.5V6M14.5 2.5V6M9.5 18v3.5M14.5 18v3.5M2.5 9.5H6M2.5 14.5H6M18 9.5h3.5M18 14.5h3.5"/>',
      thumb:
        '<path d="M7.5 10.5v10h-3v-10zM7.5 10.5l3.6-7a2 2 0 0 1 3.4 1.6l-.8 4.4h5.3a2 2 0 0 1 2 2.4l-1.4 7a2 2 0 0 1-2 1.6H7.5"/>',
      wand: '<circle cx="16.5" cy="7.5" r="4.5"/><path d="M13.3 10.7 4 20"/>',
      slim: '<path d="M12 3c1.6 0 2.5 1.5 2.5 3.5v11c0 2-1 3.5-2.5 3.5s-2.5-1.5-2.5-3.5v-11C9.5 4.5 10.4 3 12 3Z"/>',
      full: '<rect x="6.5" y="3" width="11" height="18" rx="5.5"/>',
      rings: '<circle cx="12" cy="16.5" r="3.5"/><circle cx="12" cy="9.2" r="2.6"/><circle cx="12" cy="4.2" r="1.6"/>',
      shrug:
        '<circle cx="12" cy="12" r="8.5"/><path d="M9.6 9.6a2.4 2.4 0 1 1 3.3 2.2c-.6.3-.9.8-.9 1.4v.5"/><circle cx="12" cy="16.6" r=".7" fill="currentColor"/>',
      arrowR: '<path d="M5 12h14m-5-5 5 5-5 5"/>',
      arrowL: '<path d="M19 12H5m5-5-5 5 5 5"/>',
      check: '<path d="m5 12.5 4.2 4.2L19 7"/>',
      cart: '<path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
      redo: '<path d="M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7"/>',
      edit: '<path d="M4 20h4L19 9l-4-4L4 16z"/><path d="m13.5 6.5 4 4"/>',
    },
    svg = (k) => `<svg viewBox="0 0 24 24" aria-hidden="true">${I[k] || ""}</svg>`,
    bars = (n) =>
      `<span class="ccq-bars" aria-hidden="true">${[1, 2, 3, 4, 5].map((i) => `<i class="${i <= n ? "on" : ""}"></i>`).join("")}</span>`,
    o = (id, label, hint, icon, react) => ({ id, label, hint, icon, react }),
    QS = {
      zone: {
        kicker: "Kezdj\xFCk az alapokkal",
        title: "Hol szeretn\xE9d legink\xE1bb \xE9rezni?",
        help: "Nincs rossz v\xE1lasz. \xC9s ha m\xE9g nem tudod, az is teljesen rendben van.",
        opts: [
          o(
            "kivul",
            "K\xEDv\xFCl",
            "a csikl\xF3n, a felsz\xEDnen",
            "target",
            "K\xEDv\xFCl, \xE9rtj\xFCk. Ott lakik a legt\xF6bb idegv\xE9gz\u0151d\xE9s, j\xF3 helyen j\xE1rsz.",
          ),
          o("belul", "Bel\xFCl", "G-pont, h\xFCvely", "curve", "Bel\xFCl, rendben. Ir\xE1ny a G-pont."),
          o(
            "kettos",
            "K\xEDv\xFCl \xE9s bel\xFCl egyszerre",
            "a dupla \xE9lm\xE9ny",
            "dual",
            "K\xEDv\xFCl \xE9s bel\xFCl egyszerre. Nagyrat\xF6r\u0151, tetszik.",
          ),
          o(
            "anal",
            "An\xE1lisan is kipr\xF3b\xE1ln\xE1m",
            "ak\xE1r teljesen kezd\u0151k\xE9nt",
            "plug",
            "Szuper. Csak talpas, biztons\xE1gos j\xE1t\xE9kok k\xF6zt keres\xFCnk.",
          ),
          o(
            "nemtudom",
            "Fogalmam sincs, ez\xE9rt vagyok itt \u{1F605}",
            "semmi gond, kider\xEDtj\xFCk",
            "shrug",
            "Pont ez\xE9rt vagyunk itt. K\xE9rdezz\xFCk m\xE1shogy.",
          ),
        ],
      },
      vibe: {
        kicker: "K\xE9rdezz\xFCk m\xE1shogy",
        title: "Melyik hangzik most a legjobban?",
        help: "Ne gondold t\xFAl, \xE1ltal\xE1ban az els\u0151 meg\xE9rz\xE9s a j\xF3.",
        opts: [
          o(
            "celzott",
            "Valami, ami gyorsan megtal\xE1lja a megfelel\u0151 pontot",
            "c\xE9lzott, gyors \xE9lm\xE9ny",
            "pin",
            "Gyors \xE9s c\xE9lzott. A kedvenceink k\xF6z\xFCl nem egy pont ilyen.",
          ),
          o(
            "belulis",
            "J\xF3lesne valami bel\xFCl is",
            "telts\xE9g, G-pont",
            "curve",
            "Akkor bel\xFCl is keres\xFCnk.",
          ),
          o(
            "mindent",
            "Mindent egyszerre k\xE9rek \u{1F608}",
            "k\xEDv\xFCl \xE9s bel\xFCl",
            "dual",
            "Mindent egyszerre? Ilyen j\xE1t\xE9k is van, nem is egy.",
          ),
          o(
            "eros",
            "Ink\xE1bb er\u0151s, m\xE9ly rezg\xE9sre v\xE1gyom",
            "nem a halk z\xFCmm\xF6g\xE9s",
            "bolt",
            "Er\u0151 kell. \xC9rtett\xFCk.",
          ),
          o(
            "mozog",
            "J\xF3 lenne, ha mozogna is, nem csak rezegne",
            "l\xF6k\u0151 vagy forg\xF3 mozg\xE1s",
            "move",
            "Mozg\xE1s, nem csak rezg\xE9s. Erre is van megold\xE1s.",
          ),
          o(
            "meglepetes",
            "Lepjetek meg valamivel, amit m\xE9g nem pr\xF3b\xE1ltam",
            "k\xFCl\xF6nleges technol\xF3gi\xE1k",
            "gift",
            "Meglepet\xE9s lesz. \xCDg\xE9rj\xFCk, j\xF3 \xE9rtelemben.",
          ),
        ],
      },
      exp: {
        kicker: "Csak hogy tudjuk",
        title: "Mennyi tapasztalatod van szexj\xE1t\xE9kokkal?",
        help: "Ezzel csak azt hangoljuk, mennyire legyen kezd\u0151bar\xE1t a tal\xE1lat.",
        opts: [
          o(
            "elso",
            "Ez lenne az els\u0151.",
            "teljesen \xFAj terep",
            "seed",
            "Az els\u0151 mindig k\xFCl\xF6nleges. Kezd\u0151bar\xE1t vonalon maradunk.",
          ),
          o(
            "volt",
            "Volt m\xE1r 1-2, nagyj\xE1b\xF3l tudom, mi tetszik.",
            "van m\xE1r egy kis rutin",
            "heart",
            "Remek, akkor m\xE1r sejted, mit keresel.",
          ),
          o(
            "fiok",
            "A fi\xF3kom lassan k\xFCl\xF6n ir\xE1ny\xEDt\xF3sz\xE1mot kap.",
            "halad\xF3 vagyok",
            "drawer",
            "Respekt. Akkor j\xF6hetnek a komolyabb darabok is.",
          ),
        ],
      },
      feel_kivul: {
        kicker: "Finomhangol\xE1s",
        title: "Milyen \xE9rz\xE9st szeretsz, vagy szeretn\xE9l kipr\xF3b\xE1lni?",
        help: "K\xEDv\xFCl is nagyon sokf\xE9le \xE9lm\xE9ny l\xE9tezik.",
        opts: [
          o(
            "pontos",
            "Koncentr\xE1ljon egy kis ter\xFCletre",
            "mini, bullet",
            "pin",
            "Prec\xEDz munka. Kicsi, de nagy tud\xE1s\xFA j\xE1t\xE9kok j\xF6nnek.",
          ),
          o(
            "pulzal",
            "K\xF6rbe\xF6lel\u0151, pulz\xE1l\xF3 \xE9rz\xE9s \xE9rdekel",
            "l\xE9ghull\xE1mos, \xE9rint\xE9s n\xE9lk\xFCl",
            "waves",
            "L\xE9ghull\xE1m, a modern klasszikus. J\xF3 v\xE1laszt\xE1s.",
          ),
          o(
            "mely",
            "Er\u0151s, m\xE9ly rezg\xE9st akarok",
            "wand massz\xEDroz\xF3",
            "wand",
            "M\xE9ly rezg\xE9s. A wandok pontosan tudj\xE1k, mi a dolguk.",
          ),
          o(
            "nt",
            "Nem tudom",
            "b\xE1rmelyik j\xF6het",
            "shrug",
            "Semmi gond, a t\xF6bbit a k\xF6vetkez\u0151 k\xE9rd\xE9sek el\xE1rulj\xE1k.",
          ),
        ],
      },
      feel_belul: {
        kicker: "Finomhangol\xE1s",
        title: "Milyen bels\u0151 \xE9rz\xE9s vonz ink\xE1bb?",
        help: "M\xE9ret, forma, mozg\xE1s: itt d\u0151l el, milyen lesz a karaktere.",
        opts: [
          o(
            "karcsu",
            "Ink\xE1bb karcs\xFA, k\xF6nnyen kezelhet\u0151",
            "kisebb \xE1tm\xE9r\u0151",
            "slim",
            "Karcs\xFA \xE9s bar\xE1ts\xE1gos, rendben.",
          ),
          o(
            "gpont",
            "Hat\xE1rozottabb G-pont-ingerl\xE9s",
            "hajl\xEDtott, c\xE9lzott fej",
            "curve",
            "G-pont, c\xE9lkeresztben.",
          ),
          o(
            "mozogjon",
            "Mozogjon is helyettem",
            "l\xF6k\u0151 vagy forg\xF3",
            "move",
            "Hadd dolgozzon \u0151. Meg\xE9rtj\xFCk.",
          ),
          o(
            "telt",
            "Teltebb \xE9rz\xE9st szeretn\xE9k",
            "nagyobb \xE1tm\xE9r\u0151",
            "full",
            "Teltebb \xE9rz\xE9s, \xE9rtett\xFCk.",
          ),
          o(
            "nt",
            "Nem tudom m\xE9g",
            "valami k\xF6zepes, biztos v\xE1laszt\xE1s",
            "shrug",
            "Akkor a biztos, k\xF6z\xE9putas darabok fel\xE9 n\xE9z\xFCnk.",
          ),
        ],
      },
      feel_kettos: {
        kicker: "Finomhangol\xE1s",
        title: "Melyik legyen a f\u0151szerepl\u0151?",
        help: "Ez d\xF6nti el, melyik oldal kapja a nagyobb figyelmet.",
        opts: [
          o(
            "kivul",
            "Ink\xE1bb k\xEDv\xFCl",
            "a csikl\xF3 a szt\xE1r",
            "target",
            "A csikl\xF3 a szt\xE1r, a t\xF6bbi mell\xE9kszerepl\u0151.",
          ),
          o("belul", "Ink\xE1bb bel\xFCl", "a G-pont a szt\xE1r", "curve", "A G-pont viszi a f\u0151szerepet."),
          o(
            "5050",
            "50-50, pont ez\xE9rt vagyok itt",
            "egyenl\u0151 munkamegoszt\xE1s",
            "dual",
            "Igazs\xE1gos munkamegoszt\xE1s. A nyuszik ebben a legjobbak.",
          ),
        ],
      },
      feel_anal: {
        kicker: "Finomhangol\xE1s",
        title: "Hogyan kezden\xE9d?",
        help: "An\xE1l j\xE1t\xE9kokn\xE1l a lass\xFA, fokozatos kezd\xE9s a nyer\u0151. \xC9s a b\u0151s\xE9ges s\xEDkos\xEDt\xF3.",
        opts: [
          o(
            "kicsi",
            "Egy kicsi, kezd\u0151bar\xE1t dug\xF3val",
            "talpas, biztons\xE1gos",
            "plug",
            "Kicsi \xE9s talpas. Okos kezd\xE9s.",
          ),
          o("rezeg", "Rezegjen is", "vibr\xE1ci\xF3s dug\xF3, an\xE1l vibr\xE1tor", "waves", "Rezg\xE9ssel, rendben."),
          o(
            "gyongy",
            "Fokozatosan, gy\xF6ngyr\u0151l gy\xF6ngyre",
            "an\xE1lgy\xF6ngysor",
            "rings",
            "L\xE9p\xE9sr\u0151l l\xE9p\xE9sre, ahogy kell.",
          ),
          o(
            "nt",
            "Nem tudom m\xE9g",
            "a legbiztons\xE1gosabb kezd\xE9s",
            "shrug",
            "Akkor a legbiztons\xE1gosabb kezd\xE9s fel\xE9 n\xE9z\xFCnk.",
          ),
        ],
      },
      use: {
        kicker: "T\xE1rsas\xE1gi k\xE9rd\xE9s",
        title: "Legink\xE1bb hogyan haszn\xE1ln\xE1d?",
        help: "P\xE1rban m\xE1s szempontok sz\xE1m\xEDtanak, mint egyed\xFCl.",
        opts: [
          o("egyedul", "Egyed\xFCl", "\xE9n, magam \xE9s \xE9n", "solo", "\xC9nid\u0151. A legjobb fajta."),
          o(
            "partner",
            "Partnerrel",
            "k\xF6z\xF6s j\xE1t\xE9k",
            "duo",
            "P\xE1rban? Akkor az appos \xE9s t\xE1vir\xE1ny\xEDt\xF3s darabok el\u0151nyt kapnak.",
          ),
          o(
            "mindketto",
            "Mindkett\u0151",
            "egyed\xFCl is, k\xF6z\xF6sen is",
            "both",
            "Sokoldal\xFA legyen, \xE9rtett\xFCk.",
          ),
        ],
      },
      prio: {
        kicker: "Majdnem k\xE9sz",
        title: "Mi sz\xE1m\xEDt neked igaz\xE1n?",
        help: "V\xE1lassz legfeljebb kett\u0151t. Ebb\u0151l der\xFCl ki az, amit az eddigiekb\u0151l nem lehet.",
        multi: 2,
        opts: [
          o("kicsi", "Legyen kicsi \xE9s diszkr\xE9t", "elf\xE9r a t\xE1sk\xE1ban", "small"),
          o("eros", "Legyen nagyon er\u0151s", "a gyenge rezg\xE9s nem opci\xF3", "bolt"),
          o("egyszeru", "Legyen egyszer\u0171 haszn\xE1lni", "kev\xE9s gomb, semmi stressz", "easy"),
          o("viz", "Legyen v\xEDz\xE1ll\xF3", "k\xE1d, zuhany", "drop"),
          o("app", "Lehessen appal vagy t\xE1vir\xE1ny\xEDt\xF3val vez\xE9relni", "ak\xE1r t\xE1volr\xF3l is", "phone"),
          o("extra", "Legyen benne extra mozg\xE1s vagy technol\xF3gia", "l\xE9ghull\xE1m, l\xF6k\xE9s, app", "chip"),
          o(
            "dolgat",
            "Nem \xE9rdekelnek az extr\xE1k, csak tegye a dolg\xE1t",
            "egyszer\u0171 \xE9s megb\xEDzhat\xF3",
            "thumb",
          ),
        ],
      },
      budget: {
        kicker: "Utols\xF3 k\xE9rd\xE9s",
        title: "Mennyit sz\xE1nn\xE1l r\xE1?",
        help: "Sz\xE1nd\xE9kosan hagytuk a v\xE9g\xE9re: el\u0151bb az sz\xE1m\xEDt, mire v\xE1gysz.",
        opts: [
          o("u10", "10\xA0000 Ft alatt maradn\xE9k", "okos bel\xE9p\u0151", "b1", "Okos bel\xE9p\u0151, keres\xFCnk."),
          o(
            "10-20",
            "10\xA0000\u201320\xA0000 Ft",
            "a legn\xE9pszer\u0171bb s\xE1v",
            "b2",
            "A legn\xE9pszer\u0171bb s\xE1v. J\xF3 a szemed.",
          ),
          o(
            "20-40",
            "20\xA0000\u201340\xA0000 Ft",
            "m\xE1rk\xE1s, tart\xF3s",
            "b3",
            "M\xE1rk\xE1s \xE9s tart\xF3s, rendben.",
          ),
          o("40-70", "40\xA0000\u201370\xA0000 Ft", "pr\xE9mium", "b4", "Pr\xE9mium vonal, \xE9rtett\xFCk."),
          o(
            "70",
            "Ha t\xE9nyleg j\xF3, 70\xA0000 Ft f\xF6l\xE9 is mehet",
            "a cs\xFAcs",
            "b5",
            "A cs\xFAcsra n\xE9z\xFCnk.",
          ),
          o(
            "any",
            "Az \xE1r most nem d\xF6nt\u0151",
            "csak a legjobb tal\xE1lat sz\xE1m\xEDt",
            "spark",
            "Akkor csak a tal\xE1lat sz\xE1m\xEDt.",
          ),
        ],
      },
    },
    BUDGET = {
      u10: [0, 9999],
      "10-20": [1e4, 2e4],
      "20-40": [2e4, 4e4],
      "40-70": [4e4, 7e4],
      70: [7e4, 1 / 0],
      any: [0, 1 / 0],
    },
    VIBE_ZONE = { celzott: "kivul", belulis: "belul", mindent: "kettos", eros: "kivul", mozog: null, meglepetes: null },
    FALLBACK = { kivul: "csiklovibrator", belul: "g-pont-vibrator", kettos: "nyuszis-vibrator", anal: "anal-szex" },
    ZONE_TXT = {
      kivul: "f\u0151leg k\xEDv\xFCl szeretn\xE9d \xE9rezni",
      belul: "bel\xFCl v\xE1gysz a figyelemre",
      kettos: "k\xEDv\xFCl \xE9s bel\xFCl egyszerre k\xE9rn\xE9d",
      anal: "az an\xE1l j\xE1t\xE9kok fel\xE9 kacsingatsz",
    },
    VIBE_TXT = {
      celzott: "valami olyat keresel, ami gyorsan megtal\xE1lja a megfelel\u0151 pontot",
      belulis: "j\xF3lesne valami bel\xFCl is",
      mindent: "mindent egyszerre k\xE9rsz",
      eros: "er\u0151s, m\xE9ly rezg\xE9sre v\xE1gysz",
      mozog: "azt szeretn\xE9d, hogy mozogjon is, ne csak rezegjen",
      meglepetes: "olyat keresel, amit m\xE9g nem pr\xF3b\xE1lt\xE1l",
    },
    EXP_TXT = {
      elso: "ez lenne az els\u0151 j\xE1t\xE9kod",
      volt: "m\xE1r nagyj\xE1b\xF3l tudod, mi tetszik",
      fiok: "nem ma kezdted a gy\u0171jt\xE9st",
    },
    PRIO_TXT = {
      kicsi: "legyen kicsi \xE9s diszkr\xE9t",
      eros: "legyen benne igazi er\u0151",
      egyszeru: "nem akarsz egy bonyolult szerkezetet megtanulni",
      viz: "fontos, hogy v\xEDz\xE1ll\xF3 legyen",
      app: "appr\xF3l vagy t\xE1vir\xE1ny\xEDt\xF3val is ir\xE1ny\xEDthat\xF3 legyen",
      extra: "j\xF6het bele extra mozg\xE1s vagy technol\xF3gia",
      dolgat: "nem kellenek extr\xE1k, csak tegye a dolg\xE1t",
    },
    BUD_TXT = {
      u10: "10\xA0000 Ft alatt maradn\xE1l",
      "10-20": "10\u201320 ezer forint k\xF6z\xF6tt maradn\xE1l",
      "20-40": "20\u201340 ezer forint k\xF6z\xE9 l\u0151n\xE9l",
      "40-70": "40\u201370 ezer forintot sz\xE1nn\xE1l r\xE1",
      70: "egy igaz\xE1n j\xF3 darab\xE9rt 70 ezer f\xF6l\xE9 is elmenn\xE9l",
    },
    TRAITS = [
      [
        "airdual",
        (d) => d.air && d.int,
        "K\xEDv\xFCl l\xE9ghull\xE1mokkal, bel\xFCl rezg\xE9ssel dolgozik, egyszerre",
        "K\xEDv\xFCl + bel\xFCl",
      ],
      ["air", (d) => d.air, "L\xE9ghull\xE1mokkal ingerel, nem kell hozz\xE1 behatol\xE1s", "L\xE9ghull\xE1mos"],
      [
        "wand",
        (d) => d.wand,
        "M\xE9ly, er\u0151s rezg\xE9st ad, nem v\xE9letlen\xFCl kultikus darab",
        "M\xE9ly rezg\xE9s",
      ],
      ["thrust", (d) => d.thrust, "Nemcsak rezeg, hanem mozog is helyetted", "L\xF6k\u0151 mozg\xE1s"],
      ["rotate", (d) => d.rotate, "Forg\xF3 mozg\xE1ssal dolgozik, nem csak rezeg", "Forg\xF3 mozg\xE1s"],
      ["rabbit", (d) => d.rabbit, "Egyszerre dolgozik k\xEDv\xFCl \xE9s bel\xFCl", "K\xEDv\xFCl + bel\xFCl"],
      ["gspot", (d) => d.gspot && d.int, "Az \xEDve pont a G-pontra tal\xE1l", "G-pont"],
      ["analvib", (d) => d.analvib, "Rezeg is, nemcsak a hely\xE9n van", "Vibr\xE1l"],
      [
        "plug",
        (d) => d.plug,
        "Talpas, biztons\xE1gos forma, kezd\u0151k\xE9nt is nyugodtan kipr\xF3b\xE1lhatod",
        "Biztons\xE1gos talp",
      ],
      ["beads", (d) => d.beads, "Fokozatosan haladhatsz vele, gy\xF6ngyr\u0151l gy\xF6ngyre", "Fokozatos"],
      [
        "mini",
        (d) => d.mini,
        "Elf\xE9r a tenyeredben, \xE9s pontosan oda koncentr\xE1l, ahov\xE1 kell",
        "Kicsi, c\xE9lzott",
      ],
      ["slim", (d) => d.slim && !d.mini, "Karcs\xFA, k\xF6nnyen kezelhet\u0151 forma", "Karcs\xFA"],
      ["full", (d) => d.full, "Teltebb, hat\xE1rozottabb \xE9rzetet ad", "Teltebb"],
      ["app", (d) => d.app, "Appr\xF3l is ir\xE1ny\xEDthat\xF3, ak\xE1r t\xE1volr\xF3l", "Appos"],
      [
        "remote",
        (d) => d.remote,
        "T\xE1vir\xE1ny\xEDt\xF3val ak\xE1r a partnered kez\xE9be is adhatod az ir\xE1ny\xEDt\xE1st",
        "T\xE1vir\xE1ny\xEDt\xF3s",
      ],
      ["wear", (d) => d.wear, "Viselhet\u0151, \xEDgy a kezed szabad marad", "Viselhet\u0151"],
      ["couple", (d) => d.couple, "P\xE1rban is m\u0171k\xF6dik, nem csak egyed\xFCl", "P\xE1ros j\xE1t\xE9k"],
      ["water", (d) => d.water === 2, "V\xEDz\xE1ll\xF3, \xEDgy a k\xE1dban is veled tart", "V\xEDz\xE1ll\xF3"],
      ["quiet", (d) => d.quiet, "Halk, nem \xE1rulja el mag\xE1t", "Halk"],
      ["strong", (d) => d.pow >= 4, "Van benne er\u0151 b\u0151ven", "Er\u0151s"],
      [
        "simple",
        (d) => !d.complex,
        "Egyszer\u0171 kezelni, nem kell hozz\xE1 \xFAtmutat\xF3t b\xFAjni",
        "Egyszer\u0171",
      ],
      ["beginner", (d) => d.lvlMin === 1, "Kezd\u0151knek is bar\xE1ts\xE1gos", "Kezd\u0151bar\xE1t"],
    ],
    TRAIT = Object.fromEntries(TRAITS.map((t) => [t[0], t])),
    HEADS = [
      ["Megvan.", "Szerint\xFCnk \u0151 lesz a <em>te embered.</em>"],
      ["2. jel\xF6lt", "Ok\xE9. Akkor tal\xE1n <em>\u0151?</em>"],
      ["3. jel\xF6lt", "Harmadszorra <em>szerencs\xE9s?</em>"],
      ["4. jel\xF6lt", "M\xE9g egy <em>komoly jel\xF6lt.</em>"],
      ["5. jel\xF6lt", "Az utols\xF3 <em>\xE1sz a pakliban.</em>"],
    ],
    esc = (s) =>
      String(s ?? "").replace(
        /[&<>"']/g,
        (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c],
      ),
    arr = (x) => (Array.isArray(x) ? x : x ? [x] : []),
    clamp = (v, a, b) => Math.max(a, Math.min(b, v)),
    wait = (ms) => new Promise((r) => setTimeout(r, ms)),
    cap = (s) => s && s.charAt(0).toUpperCase() + s.slice(1),
    art = (name, upper) => {
      const a = /^[aáeéiíoóöőuúüű]/i.test(name) ? "az" : "a";
      return upper ? cap(a) : a;
    },
    joinHu = (list) =>
      list.length < 2 ? list.join("") : list.slice(0, -1).join(", ") + " \xE9s " + list[list.length - 1],
    shortName = (t) => {
      const s = String(t || "").split(/\s[–—-]\s/)[0],
        out = [];
      for (const w of s.split(/\s+/)) {
        if (
          (out.length && /^[a-záéíóöőúüű]/.test(w)) ||
          (out.length >= 2 && /vibrátor|izgató|masszírozó|dugó|dildó|gyöngy/i.test(w))
        )
          break;
        out.push(w);
      }
      return out.join(" ") || s;
    },
    track = (name, data) => {
      try {
        window.Shopify &&
          Shopify.analytics &&
          typeof Shopify.analytics.publish == "function" &&
          Shopify.analytics.publish(name, data || {});
      } catch {}
      try {
        (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {}));
      } catch {}
    },
    store = {
      get: () => {
        try {
          return JSON.parse(sessionStorage.getItem("ccq:v1") || "null");
        } catch {
          return null;
        }
      },
      set: (v) => {
        try {
          sessionStorage.setItem("ccq:v1", JSON.stringify(v));
        } catch {}
      },
      clear: () => {
        try {
          sessionStorage.removeItem("ccq:v1");
        } catch {}
      },
    },
    NON_TOY =
      /síkosító|tisztító|kiegészítő|óvszer|masszázs|gyertya|kehely|péniszgyűrű|maszturbátor|férfi játékszer|bilincs|maszk|korbács|nyakörv|kötözés|szájpecek|csipesz|fehérnemű/i,
    NON_TOY_TITLE = /töltőkábel|töltő kábel|\btöltő\b|feltét|pótfej|szilikon tok|ajándékutalvány/i,
    enrich = (p) => {
      const ty = new Set(arr(p.ty)),
        st = new Set(arr(p.st)),
        fu = new Set(arr(p.fu)),
        hz = new Set(arr(p.hz)),
        tp = arr(p.tp),
        t = String(p.t || "").toLowerCase(),
        any = (set, ...k) => k.some((x) => set.has(x)),
        d = {};
      ((d.air = fu.has("L\xE9ghull\xE1mos") || ty.has("L\xE9ghull\xE1mos csikl\xF3izgat\xF3") || /léghull/.test(t)),
        (d.wand = ty.has("Wand massz\xEDroz\xF3") || /\bwand\b/.test(t)),
        (d.thrust = fu.has("L\xF6k\u0151 mozg\xE1s") || ty.has("L\xF6k\u0151 vibr\xE1tor") || /lökő/.test(t)),
        (d.rotate = fu.has("Forg\xF3 mozg\xE1s") || ty.has("Forg\xF3 vibr\xE1tor") || /forgó/.test(t)),
        (d.rabbit = ty.has("Nyuszis vibr\xE1tor") || /nyuszis (vibrátor|g-pont)/.test(t)),
        (d.gspot = any(ty, "G-pont-vibr\xE1tor", "G-pont-dild\xF3") || st.has("G-pont") || /g-pont/.test(t)),
        (d.bullet =
          any(ty, "Minivibr\xE1tor", "Vibrotoj\xE1s, bullet", "Ujjvibr\xE1tor") ||
          /\bmini\b|bullet|vibratojás|ujjvibr/.test(t)),
        (d.couple =
          ty.has("P\xE1rvibr\xE1tor") ||
          st.has("P\xE1ros j\xE1t\xE9k") ||
          hz.has("P\xE1ros j\xE1t\xE9khoz") ||
          /párvibr/.test(t)),
        (d.wear = ty.has("Bugyivibr\xE1tor") || hz.has("Visel\xE9shez") || /bugyi|viselhető/.test(t)),
        (d.app =
          fu.has("Applik\xE1ci\xF3val vez\xE9relhet\u0151") || ty.has("Okos vibr\xE1tor") || /applikáci|appos/.test(t)),
        (d.remote =
          fu.has("T\xE1vir\xE1ny\xEDt\xF3s") || ty.has("T\xE1vir\xE1ny\xEDt\xF3s vibr\xE1tor") || /távirány/.test(t)),
        (d.water = fu.has("V\xEDz\xE1ll\xF3")
          ? 2
          : fu.has("Fr\xF6ccsen\xE9s\xE1ll\xF3")
            ? 1
            : /vízálló/.test(t)
              ? 2
              : 0),
        (d.known = fu.size > 0),
        (d.quiet = fu.has("Halk m\u0171k\xF6d\xE9s")),
        (d.warm = fu.has("Meleg\xEDt\u0151 funkci\xF3")),
        (d.plug = ty.has("An\xE1ldug\xF3") || /análdugó|anál dugó|\bplug\b/.test(t)),
        (d.analvib = any(ty, "An\xE1lvibr\xE1tor") || (d.plug && (fu.has("Vibr\xE1l\xF3") || /vibrác|vibrát/.test(t)))),
        (d.beads = ty.has("An\xE1lgy\xF6ngysor") || /gyöngysor|análgyöngy/.test(t)),
        (d.anal =
          st.has("An\xE1l") ||
          d.plug ||
          d.analvib ||
          d.beads ||
          any(ty, "An\xE1ldild\xF3", "An\xE1lis j\xE1t\xE9kszer", "An\xE1lvibr\xE1tor")),
        (d.ext =
          st.has("Csikl\xF3") ||
          d.air ||
          d.wand ||
          any(ty, "Csikl\xF3vibr\xE1tor", "Csikl\xF3izgat\xF3") ||
          /csikló/.test(t)),
        (d.int =
          st.has("G-pont") ||
          st.has("H\xFCvely") ||
          d.gspot ||
          d.thrust ||
          any(ty, "Klasszikus vibr\xE1tor", "\xC9leth\u0171 vibr\xE1tor", "R\xFAdvibr\xE1tor", "G-pont-dild\xF3")),
        d.anal && !st.has("G-pont") && !st.has("H\xFCvely") && !d.gspot && (d.int = !1),
        d.rabbit && ((d.ext = !0), (d.int = !0)),
        (d.dual = d.ext && d.int));
      const dia = parseFloat(p.d) || 0;
      ((d.mini = (d.bullet || p.me === "Mini" || p.me === "Kicsi") && !d.wand),
        (d.slim = !d.wand && (dia ? dia <= 3.2 : d.mini)),
        (d.full = dia ? dia >= 4.2 : p.me === "Nagy" || p.me === "XL"),
        (d.tech = [d.air, d.thrust, d.rotate, d.app, d.warm].filter(Boolean).length),
        (d.complex = d.app || d.remote || d.thrust || d.rotate),
        (d.pow = parseInt(p.in, 10) || (d.wand ? 5 : d.thrust || d.air ? 4 : d.rabbit ? 3 : d.mini ? 2 : 3)));
      const L = { Kezdő: 1, Középhaladó: 2, Haladó: 3 },
        lv = tp.map((x) => L[x]).filter(Boolean);
      if (lv.length) ((d.lvlMin = Math.min(...lv)), (d.lvlMax = Math.max(...lv)));
      else {
        let l = 1;
        (p.p > 45e5 && l++,
          (d.thrust || d.full || (d.analvib && !d.plug) || d.pow >= 5) && l++,
          d.mini && p.p < 2e6 && (l = 1),
          (d.lvlMin = d.lvlMax = clamp(l, 1, 3)));
      }
      const tyStr = [...ty].join("|"),
        male = ty.has("Prosztatavibr\xE1tor") && !ty.has("An\xE1lvibr\xE1tor");
      return (
        (d.toy =
          (d.ext || d.int || d.anal || d.couple || d.wear) &&
          !male &&
          !(NON_TOY.test(tyStr) && !ty.has("P\xE1rvibr\xE1tor")) &&
          !NON_TOY_TITLE.test(t)),
        {
          id: p.id,
          h: p.h,
          t: p.t,
          b: p.b,
          u: p.u,
          img: p.i,
          price: Number(p.p) || 0,
          cmp: Number(p.c) || 0,
          v: p.v,
          n: p.n,
          d,
          name: shortName(p.t),
        }
      );
    },
    zoneOf = (a) => (a.zone && a.zone !== "nemtudom" ? a.zone : a.vibe ? VIBE_ZONE[a.vibe] : null),
    score = (p, a, featured) => {
      const d = p.d;
      let s = 0,
        veto = !1;
      const why = [],
        add = (n, key) => {
          ((s += n), n <= -3 && (veto = !0), n >= 2 && key && why.push(key));
        },
        z = zoneOf(a);
      switch (
        (z === "kivul"
          ? d.ext && !d.int
            ? add(3, "ext")
            : d.ext
              ? add(1)
              : add(-3)
          : z === "belul"
            ? d.int && !d.ext
              ? add(3, "int")
              : d.int
                ? add(1)
                : add(-3)
            : z === "kettos"
              ? d.dual
                ? add(3, "dual")
                : add(-3)
              : z === "anal" && (d.anal ? add(4, "anal") : add(-8)),
        z !== "anal" && a.zone && d.anal && !d.ext && !d.int && add(-6),
        a.vibe)
      ) {
        case "celzott":
          (d.air ? add(3, "air") : d.mini && add(2, "mini"), d.wand && add(-1));
          break;
        case "belulis":
          d.gspot && add(2, "gspot");
          break;
        case "mindent":
          (d.rabbit && add(2, "rabbit"), d.air && d.int && add(2, "airdual"));
          break;
        case "eros":
          (d.wand && add(3, "wand"), d.pow >= 4 && add(1), d.mini && !d.air && add(-1));
          break;
        case "mozog":
          (d.thrust ? add(3, "thrust") : d.rotate ? add(2, "rotate") : add(-2), d.int || add(-3));
          break;
        case "meglepetes":
          d.tech ? add(Math.min(3, 1 + d.tech), "tech") : add(-1);
          break;
        default:
          break;
      }
      a.exp === "elso"
        ? (d.lvlMin === 1 && add(2, "beginner"),
          d.lvlMin === 3 && add(-3),
          p.price > 6e6 && add(-2),
          d.full && add(-2),
          d.thrust && add(-1),
          d.pow >= 5 && add(-1))
        : a.exp === "volt"
          ? d.lvlMin <= 2 && d.lvlMax >= 2 && add(1)
          : a.exp === "fiok" &&
            (d.lvlMax === 3 && add(2), d.tech && add(1), d.lvlMax === 1 && p.price < 8e5 && add(-1));
      const f = z ? a["feel_" + z] : null;
      switch (z + ":" + f) {
        case "kivul:pontos":
          (d.mini ? add(3, "mini") : d.air && add(1), d.wand && add(-3));
          break;
        case "kivul:pulzal":
          d.air ? add(3, "air") : add(-1);
          break;
        case "kivul:mely":
          (d.wand ? add(3, "wand") : d.pow >= 4 && add(1), d.mini && !d.air && add(-2));
          break;
        case "belul:karcsu":
          (d.slim && add(3, "slim"), d.full && add(-3), d.gspot && add(1));
          break;
        case "belul:gpont":
          d.gspot && add(3, "gspot");
          break;
        case "belul:mozogjon":
          d.thrust ? add(3, "thrust") : d.rotate ? add(2, "rotate") : add(-1);
          break;
        case "belul:telt":
          (d.full && add(3, "full"), (d.slim || d.mini) && add(-3));
          break;
        case "belul:nt":
          (d.lvlMin <= 2 && add(1), !d.full && !d.mini && add(1));
          break;
        case "kettos:kivul":
          d.air && d.int ? add(3, "airdual") : d.rabbit && add(1);
          break;
        case "kettos:belul":
          (d.thrust ? add(2, "thrust") : d.rotate && add(2, "rotate"), d.gspot && add(2, "gspot"));
          break;
        case "kettos:5050":
          d.rabbit && add(3, "rabbit");
          break;
        case "anal:kicsi":
          (d.plug && add(3, "plug"), (d.slim || d.mini) && add(1), d.full && add(-3), d.lvlMin === 1 && add(1));
          break;
        case "anal:rezeg":
          d.analvib ? add(3, "analvib") : add(-1);
          break;
        case "anal:gyongy":
          d.beads && add(3, "beads");
          break;
        case "anal:nt":
          (d.plug && add(1), d.lvlMin === 1 && add(1));
          break;
        default:
          break;
      }
      (a.use === "partner"
        ? (d.couple && add(3, "couple"), d.remote && add(2, "remote"), d.app && add(2, "app"), d.wear && add(2, "wear"))
        : a.use === "mindketto"
          ? (d.couple && add(1), (d.app || d.remote) && add(1))
          : a.use === "egyedul" && d.couple && !d.dual && !d.ext && !d.int && add(-1),
        (a.prio || []).forEach((k) => {
          switch (k) {
            case "kicsi":
              ((d.mini || d.slim) && add(2, "mini"), d.wand && add(-3), d.full && add(-2), d.quiet && add(1));
              break;
            case "eros":
              (d.pow >= 4 && add(2, "strong"), d.wand && add(1), d.mini && !d.air && add(-1));
              break;
            case "egyszeru":
              (d.complex || add(2, "simple"), d.lvlMin === 1 && add(1), d.app && add(-1));
              break;
            case "viz":
              d.water === 2 ? add(3, "water") : d.water === 1 ? add(1) : add(d.known ? -3 : -1);
              break;
            case "app":
              d.app ? add(3, "app") : d.remote ? add(2, "remote") : add(-3);
              break;
            case "extra":
              d.tech ? add(Math.min(3, 1 + d.tech), "tech") : add(-1);
              break;
            case "dolgat":
              (d.tech || add(2, "simple"), d.app && add(-1));
              break;
            default:
              break;
          }
        }));
      const feat = featured.has(p.h) ? 1 : 0;
      return ((s += feat), p.cmp > p.price && (s += 0.5), { s, veto, why, feat });
    },
    REQS = (a) => {
      const z = zoneOf(a),
        out = [],
        req = (k, ok, miss) => out.push({ k, ok, miss });
      z === "kivul"
        ? req("zone", (d) => d.ext, "nem kívülre, a csiklóra készült")
        : z === "belul"
          ? req("zone", (d) => d.int, "nem belső használatra készült")
          : z === "kettos"
            ? req("zone", (d) => d.dual, "nem dolgozik egyszerre kívül és belül")
            : z === "anal" && req("zone", (d) => d.anal, "nem anál játék");
      const strongVibe = a.zone === "nemtudom" && ["celzott", "eros", "mozog", "meglepetes"].includes(a.vibe);
      if (strongVibe)
        ({
          celzott: () => req("vibe", (d) => d.air || d.mini, "nem célzott, pontszerű ingerlésre készült"),
          eros: () => req("vibe", (d) => d.wand || (d.pow >= 4 && !d.air), "nem ad igazán erős, mély rezgést"),
          mozog: () => req("vibe", (d) => d.thrust || d.rotate, "nem mozog, csak rezeg"),
          meglepetes: () => req("vibe", (d) => d.tech > 0, "nincs benne különleges technológia"),
        })[a.vibe]();
      const f = z && !strongVibe ? a["feel_" + z] : null,
        FEEL = {
          "kivul:pontos": [(d) => d.mini, "nem kicsi, célzott forma"],
          "kivul:pulzal": [(d) => d.air, "nincs benne léghullám"],
          "kivul:mely": [(d) => d.wand || (d.pow >= 4 && !d.air), "nem ad igazán mély, erős rezgést"],
          "belul:karcsu": [(d) => (d.slim || d.mini) && !d.full, "nem karcsú forma"],
          "belul:gpont": [(d) => d.gspot, "nem kifejezetten G-pontra hajlított"],
          "belul:mozogjon": [(d) => d.thrust || d.rotate, "nem mozog magától, csak rezeg"],
          "belul:telt": [(d) => d.full, "nem teltebb méretű"],
          "anal:kicsi": [(d) => d.plug && !d.full, "nem kicsi, talpas dugó"],
          "anal:rezeg": [(d) => d.analvib, "nem rezeg"],
          "anal:gyongy": [(d) => d.beads, "nem gyöngysor"],
        }[z + ":" + f];
      FEEL && req("feel", FEEL[0], FEEL[1]);
      a.exp === "elso" && req("exp", (d) => d.lvlMin === 1, "nem kifejezetten kezdőknek való");
      arr(a.prio).forEach((k) => {
        const P = {
          kicsi: [(d) => (d.mini || d.slim) && !d.wand && !d.full, "nem kicsi és diszkrét"],
          eros: [(d) => d.pow >= 4, "nem a legerősebb fajta"],
          egyszeru: [(d) => !d.complex, "több funkciója van, kicsit több tanulást kér"],
          viz: [
            (d) => d.water === 2,
            (d) => (d.water === 1 ? "csak fröccsenésálló, kádba nem viheted" : d.known ? "nem vízálló" : "nem tudjuk biztosan, hogy vízálló"),
          ],
          app: [(d) => d.app || d.remote, "nem appos, és távirányítója sincs"],
          extra: [(d) => d.tech > 0, "nincs benne extra mozgás vagy technológia"],
        }[k];
        P && req("prio:" + k, P[0], P[1]);
      });
      return out;
    },
    missOf = (reqs, d) => reqs.filter((r) => !r.ok(d)).map((r) => (typeof r.miss == "function" ? r.miss(d) : r.miss)),
    maxPossible = (a) => {
      const z = zoneOf(a);
      let m = z === "anal" ? 4 : 3;
      (a.vibe && (m += 3), (m += a.exp === "volt" ? 1 : 2));
      const f = z ? a["feel_" + z] : null;
      return (
        f && f !== "nt" && (m += 3),
        (m += a.use === "partner" ? 5 : a.use === "mindketto" ? 2 : 0),
        (m += (a.prio || []).length * 3),
        m
      );
    },
    init = (root) => {
      const cfgEl = root.querySelector("[data-ccq-config]");
      let cfg = {};
      try {
        cfg = JSON.parse(cfgEl ? cfgEl.textContent : "{}");
      } catch {}
      const RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        base = String(cfg.root || "/").replace(/\/$/, ""),
        featured = new Set(cfg.featured || []),
        sources = String(cfg.sources || "vibrator")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean),
        money = (cents) => {
          try {
            return new Intl.NumberFormat("hu-HU", {
              style: "currency",
              currency: cfg.currency || "HUF",
              maximumFractionDigits: 0,
            }).format((Number(cents) || 0) / 100);
          } catch {
            return Math.round((Number(cents) || 0) / 100).toLocaleString("hu-HU") + " Ft";
          }
        },
        $ = (s, el) => (el || root).querySelector(s),
        screens = {};
      root.querySelectorAll("[data-ccq-screen]").forEach((el) => {
        screens[el.dataset.ccqScreen] = el;
      });
      const deck = $("[data-ccq-deck]"),
        progressEl = $("[data-ccq-progress]"),
        poolEl = $("[data-ccq-pool]"),
        bubble = $("[data-ccq-bubble]"),
        backBtn = $("[data-ccq-back]"),
        resultEl = $("[data-ccq-result]");
      let S = { a: {}, i: 0, phase: "intro", k: 0 },
        R = null,
        busy = !1,
        poolShown = 0,
        poolAnim = 0,
        DB = null,
        dbPromise = null;
      const getJSON = async (url) => {
          const r = await fetch(url, { credentials: "same-origin" });
          if (!r.ok) throw new Error(String(r.status));
          const txt = await r.text(),
            a = txt.indexOf("{"),
            b = txt.lastIndexOf("}");
          if (a < 0 || b < a) throw new Error("not json");
          return JSON.parse(txt.slice(a, b + 1));
        },
        th = window.Shopify && Shopify.theme,
        preview = th && th.id && th.role && th.role !== "main" ? `&preview_theme_id=${th.id}` : "",
        viewItems = async (h) => {
          const url = (pg) => `${base}/collections/${encodeURIComponent(h)}?view=cc-quiz-data&page=${pg}${preview}`,
            first = await getJSON(url(1));
          if (!first || !Array.isArray(first.items)) throw new Error("bad view");
          const rest = [];
          for (let pg = 2; pg <= Math.min(first.pages || 1, 10); pg++)
            rest.push(
              getJSON(url(pg))
                .then((x) => x.items || [])
                .catch(() => []),
            );
          return first.items.concat(...(await Promise.all(rest)));
        },
        fromPublic = (pr) => {
          const vs = pr.variants || [],
            av = vs.filter((v) => v.available);
          if (!av.length) return null;
          const cents = (x) => Math.round(parseFloat(x || 0) * 100) || 0,
            img = pr.images && pr.images[0] ? pr.images[0].src : "";
          return {
            id: pr.id,
            h: pr.handle,
            t: pr.title,
            b: pr.vendor,
            u: `${base}/products/${pr.handle}`,
            i: img ? img + (img.includes("?") ? "&" : "?") + "width=720" : "",
            p: Math.min(...vs.map((v) => cents(v.price))),
            c: Math.max(0, ...vs.map((v) => cents(v.compare_at_price))),
            v: av[0].id,
            n: vs.length,
            ty: pr.product_type ? [pr.product_type] : null,
            st: null,
            fu: null,
            tp: null,
            hz: null,
            me: null,
            d: null,
            l: null,
            in: null,
          };
        },
        publicItems = async (h) => {
          const out = [];
          for (let pg = 1; pg <= 4; pg++) {
            const list =
              (await getJSON(`${base}/collections/${encodeURIComponent(h)}/products.json?limit=250&page=${pg}`))
                .products || [];
            if (
              (list.forEach((pr) => {
                const it = fromPublic(pr);
                it && out.push(it);
              }),
              list.length < 250)
            )
              break;
          }
          return out;
        },
        sourceItems = (h) =>
          viewItems(h)
            .then((items) => {
              if (!items.length) throw new Error("empty view");
              return items;
            })
            .catch(
              (err) => (
                console.warn(
                  "[cc-quiz] adatforr\xE1s (" + h + "):",
                  err && err.message,
                  "\u2013 tartal\xE9k: products.json",
                ),
                publicItems(h).catch(
                  (e2) => (console.warn("[cc-quiz] tartal\xE9k is hib\xE1s (" + h + "):", e2 && e2.message), []),
                )
              ),
            ),
        load = () =>
          dbPromise ||
          ((dbPromise = (async () => {
            const all = await Promise.all(sources.map(sourceItems)),
              seen = new Map();
            all.forEach((items) =>
              items.forEach((it) => {
                it && !seen.has(it.id) && seen.set(it.id, it);
              }),
            );
            const list = [...seen.values()].map(enrich).filter((p) => p.d.toy && p.img && p.price >= 15e4);
            if (!list.length) throw new Error("empty");
            return list;
          })()),
          dbPromise
            .then((l) => {
              ((DB = l), S.phase === "play" && updatePool());
            })
            .catch((e) => {
              (console.warn("[cc-quiz] nincs bet\xF6lthet\u0151 term\xE9k:", e && e.message),
                (DB = []),
                (dbPromise = null));
            }),
          dbPromise),
        flow = (a) => {
          const f = ["zone"];
          (a.zone === "nemtudom" && f.push("vibe"), f.push("exp"));
          const z = zoneOf(a),
            strongVibe = a.zone === "nemtudom" && ["celzott", "eros", "mozog", "meglepetes"].includes(a.vibe);
          return (
            z && !strongVibe ? f.push("feel_" + z) : a.zone || f.push("feel_kivul"),
            f.push("use", "prio", "budget"),
            f
          );
        },
        answeredUpTo = (a, upto) => {
          const f = flow(a).slice(0, upto),
            out = {};
          return (
            f.forEach((k) => {
              (k.startsWith("feel_"), a[k] != null && (out[k] = a[k]));
            }),
            out
          );
        },
        show = (name) => {
          Object.keys(screens).forEach((k) => {
            const on = k === name;
            ((screens[k].hidden = !on), screens[k].classList.toggle("is-active", on));
          });
        },
        scrollTop = () => {
          const r = root.getBoundingClientRect();
          (r.top < -4 || r.top > window.innerHeight * 0.5) &&
            window.scrollTo({ top: window.scrollY + r.top - 72, behavior: RM ? "auto" : "smooth" });
        },
        save = () => store.set({ a: S.a, i: S.i, phase: S.phase, k: S.k, at: Date.now() }),
        countPool = () => {
          if (!DB || !DB.length) return null;
          const a = answeredUpTo(S.a, S.i),
            [lo, hi] = a.budget ? BUDGET[a.budget] : [0, 1 / 0];
          let n = 0;
          return (
            DB.forEach((p) => {
              (a.budget && (p.price < lo * 100 || p.price > hi * 100)) || score(p, a, featured).veto || n++;
            }),
            n
          );
        },
        updatePool = () => {
          const n = countPool();
          if (n == null) {
            poolEl.textContent = "\u2026";
            return;
          }
          const from = poolShown || n;
          if (((poolShown = n), cancelAnimationFrame(poolAnim), RM || from === n)) {
            poolEl.textContent = n;
            return;
          }
          const t0 = performance.now(),
            step = (t) => {
              const k = Math.min(1, (t - t0) / 700),
                e = 1 - Math.pow(1 - k, 3);
              ((poolEl.textContent = Math.round(from + (n - from) * e)),
                k < 1 && (poolAnim = requestAnimationFrame(step)));
            };
          poolAnim = requestAnimationFrame(step);
        },
        say = (text) => {
          if (!text) {
            bubble.classList.remove("is-on");
            return;
          }
          (bubble.classList.remove("is-on"),
            (bubble.innerHTML = `<span class="ccq-bubble__av">${svg("heart")}</span><span class="ccq-bubble__tx">${esc(text)}</span>`),
            requestAnimationFrame(() => requestAnimationFrame(() => bubble.classList.add("is-on"))));
        },
        renderProgress = (f) => {
          (progressEl.children.length !== f.length &&
            (progressEl.innerHTML = f.map(() => '<span class="ccq-seg"></span>').join("")),
            [...progressEl.children].forEach((seg, k) => {
              (seg.classList.toggle("is-done", k < S.i), seg.classList.toggle("is-now", k === S.i));
            }),
            progressEl.setAttribute("aria-valuemax", f.length),
            progressEl.setAttribute("aria-valuenow", S.i + 1));
        },
        optIcon = (op) => (/^b\d$/.test(op.icon) ? bars(Number(op.icon.slice(1))) : svg(op.icon)),
        buildCard = (qid, idx, total) => {
          const q = QS[qid],
            multi = q.multi || 0,
            cur = S.a[qid],
            sel = multi ? new Set(arr(cur)) : null,
            card = document.createElement("div");
          ((card.className = "ccq-card"), (card.dataset.q = qid));
          const tid = `ccq-q-${root.id}-${qid}`;
          return (
            card.setAttribute("role", "group"),
            card.setAttribute("aria-labelledby", tid),
            (card.innerHTML = `
        <p class="ccq-q__kicker">${esc(q.kicker)}<span>${idx + 1} / ${total}</span></p>
        <h2 class="ccq-q__title" id="${tid}" tabindex="-1">${esc(q.title)}</h2>
        ${q.help ? `<p class="ccq-q__help">${esc(q.help)}</p>` : ""}
        ${
          multi
            ? `<div class="ccq-multi">
            <p class="ccq-multi__note" aria-live="polite" data-ccq-note></p>
            <button type="button" class="ccq-btn ccq-multi__go" data-ccq-next></button>
          </div>`
            : ""
        }
        <div class="ccq-opts" data-n="${q.opts.length}">
          ${q.opts
            .map((op, k) => {
              const on = multi ? sel.has(op.id) : cur === op.id,
                aria = multi ? `role="checkbox" aria-checked="${on}"` : `aria-pressed="${on}"`;
              return `<button type="button" class="ccq-opt" data-v="${op.id}" ${aria}>
              <span class="ccq-opt__ic">${optIcon(op)}</span>
              <span class="ccq-opt__tx"><span class="ccq-opt__l">${esc(op.label)}</span>${op.hint ? `<span class="ccq-opt__h">${esc(op.hint)}</span>` : ""}</span>
              <span class="ccq-opt__k${multi ? " is-box" : ""}"><b>${multi ? "" : k + 1}</b>${svg("check")}</span>
            </button>`;
            })
            .join("")}
        </div>`),
            multi && syncMulti(card),
            card
          );
        },
        syncMulti = (card) => {
          const q = QS[card.dataset.q],
            sel = arr(S.a[card.dataset.q]);
          card.querySelectorAll(".ccq-opt").forEach((b) => {
            const on = sel.includes(b.dataset.v);
            (b.setAttribute("aria-checked", String(on)), b.classList.toggle("is-dim", !on && sel.length >= q.multi));
          });
          const note = card.querySelector("[data-ccq-note]");
          if (note) {
            const dots = Array.from(
              { length: q.multi },
              (_, k) => `<i class="${k < sel.length ? "on" : ""}"></i>`,
            ).join("");
            note.innerHTML = `<span class="ccq-multi__dots" aria-hidden="true">${dots}</span><span><b>${sel.length}</b>/${q.multi} kiv\xE1lasztva</span>`;
          }
          const next = card.querySelector("[data-ccq-next]");
          if (next) {
            const empty = sel.length === 0;
            (next.classList.toggle("ccq-btn--ghost", empty),
              next.classList.toggle("ccq-btn--solid", !empty),
              next.classList.toggle("is-ready", sel.length >= q.multi),
              (next.innerHTML = `<span>${empty ? "Kihagyom" : "Tov\xE1bb"}</span>${svg("arrowR")}`));
          }
        },
        swapCard = (card, dir) => {
          const old = deck.querySelector(".ccq-card");
          if ((deck.appendChild(card), !old)) return;
          if (RM || !card.animate) {
            old.remove();
            return;
          }
          const ease = "cubic-bezier(.22,1,.36,1)";
          dir >= 0
            ? ((old.style.zIndex = 3),
              (old.animate(
                [
                  { transform: "none", opacity: 1 },
                  { transform: "translate(118%, -6%) rotate(16deg)", opacity: 0 },
                ],
                { duration: 560, easing: "cubic-bezier(.55,0,.7,.2)", fill: "forwards" },
              ).onfinish = () => old.remove()),
              card.animate(
                [
                  { transform: "translateY(22px) scale(.93)", opacity: 0.35 },
                  { transform: "none", opacity: 1 },
                ],
                { duration: 640, easing: ease, delay: 120, fill: "backwards" },
              ))
            : ((card.style.zIndex = 3),
              (old.animate(
                [
                  { transform: "none", opacity: 1 },
                  { transform: "translateY(22px) scale(.93)", opacity: 0 },
                ],
                { duration: 420, easing: ease, fill: "forwards" },
              ).onfinish = () => old.remove()),
              (card.animate(
                [
                  { transform: "translate(-118%, -6%) rotate(-16deg)", opacity: 0 },
                  { transform: "none", opacity: 1 },
                ],
                { duration: 620, easing: ease },
              ).onfinish = () => {
                card.style.zIndex = "";
              }));
        },
        renderQ = (dir, reactText) => {
          const f = flow(S.a);
          S.i = clamp(S.i, 0, f.length - 1);
          const qid = f[S.i];
          (renderProgress(f),
            (backBtn.disabled = !1),
            swapCard(buildCard(qid, S.i, f.length), dir),
            say(
              reactText ??
                (S.i === 0
                  ? "Szia! P\xE1r gyors k\xE9rd\xE9s, \xE9s megvan. Nincs rossz v\xE1lasz, \xEDg\xE9rj\xFCk."
                  : ""),
            ),
            updatePool(),
            save());
          const title = deck.querySelector(".ccq-card:last-child .ccq-q__title");
          (title && setTimeout(() => title.focus({ preventScroll: !0 }), RM ? 0 : 200), scrollTop());
        },
        advance = (reactText) => {
          const f = flow(S.a);
          S.i < f.length - 1 ? (S.i++, renderQ(1, reactText)) : finish();
        },
        choose = (btn) => {
          if (busy) return;
          const card = btn.closest(".ccq-card"),
            qid = card.dataset.q,
            q = QS[qid],
            v = btn.dataset.v,
            op = q.opts.find((x) => x.id === v);
          if (q.multi) {
            let sel = arr(S.a[qid]).slice();
            (sel.includes(v)
              ? (sel = sel.filter((x) => x !== v))
              : (v === "extra" && (sel = sel.filter((x) => x !== "dolgat")),
                v === "dolgat" && (sel = sel.filter((x) => x !== "extra")),
                sel.push(v),
                sel.length > q.multi && sel.shift()),
              (S.a[qid] = sel),
              syncMulti(card),
              save());
            return;
          }
          ((S.a[qid] = v),
            card.querySelectorAll(".ccq-opt").forEach((b) => b.setAttribute("aria-pressed", String(b === btn))),
            track("cc_quiz_answer", { question: qid, answer: v }),
            (busy = !0),
            setTimeout(
              () => {
                ((busy = !1), advance(op && op.react));
              },
              RM ? 60 : 340,
            ));
        },
        back = () => {
          if (!busy) {
            if (S.i <= 0) {
              ((S.phase = "intro"), save(), show("intro"), scrollTop());
              return;
            }
            (S.i--, renderQ(-1, ""));
          }
        },
        ripple = (btn, e) => {
          const r = btn.getBoundingClientRect();
          (btn.style.setProperty("--px", (e.clientX || r.left + r.width / 2) - r.left + "px"),
            btn.style.setProperty("--py", (e.clientY || r.top + r.height / 2) - r.top + "px"),
            btn.classList.remove("is-ripple"),
            btn.offsetWidth,
            btn.classList.add("is-ripple"));
        },
        familyKey = (p) => (p.b + " " + p.name).toLowerCase().replace(/\s+/g, " ").trim(),
        rank = (a = S.a) => {
          const reqs = REQS(a),
            budgeted = !!a.budget && a.budget !== "any",
            [lo, hi] = BUDGET[a.budget] || BUDGET.any,
            LO = lo * 100,
            HI = hi * 100,
            scored = DB.map((p) => {
              const x = Object.assign({ p }, score(p, a, featured));
              return (
                (x.miss = missOf(reqs, p.d)),
                (x.over = budgeted && p.price > HI ? p.price - HI : 0),
                (x.under = budgeted && p.price < LO ? LO - p.price : 0),
                (x.inB = !x.over && !x.under),
                x
              );
            }),
            ok = scored.filter((x) => !x.veto),
            pool = ok.length ? ok : scored,
            better = (x, y) =>
              y.s - x.s ||
              y.feat - x.feat ||
              (x.p.d.known === y.p.d.known ? 0 : x.p.d.known ? -1 : 1) ||
              x.p.price - y.p.price,
            fewer = (x, y) => x.miss.length - y.miss.length || better(x, y);
          let cands,
            mode = "exact";
          if (!budgeted) ((cands = pool.slice().sort(fewer)), cands.some((x) => !x.miss.length) || (mode = "partial"));
          else {
            const exact = pool.filter((x) => x.inB && !x.miss.length).sort(better);
            if (exact.length)
              // van pontos találat a keretben: csak a keretből mutatunk, utána a legkevesebbet hiányzók jönnek
              cands = exact.concat(pool.filter((x) => x.inB && x.miss.length).sort(fewer));
            else {
              mode = "none";
              // nincs pontos találat: „mindent tud, de drágább” (korlátos túllépés) vagy „belefér, de ezt nem tudja”
              const cap = Math.max(HI * 0.6, 6e5),
                cost = (x) =>
                  x.miss.length + (x.over ? (4 * x.over) / Math.max(HI, 1e6) : 0) + (x.under ? 0.5 : 0),
                upgrade = pool.filter((x) => x.over && x.over <= cap && !x.miss.length),
                cheap = pool.filter((x) => x.under && !x.miss.length),
                fit = pool.filter((x) => !x.over && x.miss.length);
              ((cands = fit.concat(upgrade, cheap).sort((x, y) => cost(x) - cost(y) || better(x, y))),
                cands.length ||
                  ((mode = "far"),
                  (cands = pool
                    .slice()
                    .sort((x, y) => x.over + x.under - (y.over + y.under) || fewer(x, y))
                    .slice(0, 8))));
              // mindkét fajta alternatíva kerüljön az első három közé, ha létezik
              const first = (fn) => cands.findIndex(fn),
                pin = (fn) => {
                  const i = first(fn);
                  i > 2 && cands.splice(1, 0, cands.splice(i, 1)[0]);
                };
              (pin((x) => x.over && !x.miss.length), pin((x) => !x.over && x.miss.length));
            }
          }
          const out = [],
            seen = new Set();
          for (const x of cands) {
            const k = familyKey(x.p);
            if (!seen.has(k) && (seen.add(k), out.push(x), out.length >= 5)) break;
          }
          return {
            list: out,
            mode,
            relaxed: mode !== "exact",
            reqs: reqs.length,
            total: DB.length,
            inStock: DB.length,
            max: maxPossible(a),
            lo,
            hi,
          };
        },
        finish = async () => {
          ((S.phase = "load"),
            save(),
            track("cc_quiz_complete", { answers: JSON.stringify(S.a) }),
            show("load"),
            scrollTop());
          const steps = $("[data-ccq-steps]"),
            shuf = $("[data-ccq-shuffle]"),
            lines = [
              "Rakt\xE1ron l\xE9v\u0151 j\xE1t\xE9kok \xE1tn\xE9z\xE9se",
              "Kisz\u0171rj\xFCk, ami nem te vagy",
              S.a.budget === "any" ? "Az \xE1r nem szempont, ahogy k\xE9rted" : "A keretedhez igaz\xEDtva",
              "Megvan a p\xE1rod",
            ];
          steps.innerHTML = lines.map((l) => `<li><i>${svg("check")}</i><span>${esc(l)}</span></li>`).join("");
          const li = steps.querySelectorAll("li"),
            fanImgs = [...root.querySelectorAll(".ccq-fan__img img")].map((im) => im.currentSrc || im.src);
          shuf.innerHTML = `<span class="ccq-shuffle__card"><span><img alt="" src="${esc(fanImgs[0] || "")}"></span></span>`;
          const shImg = shuf.querySelector("img"),
            shCard = shuf.querySelector(".ccq-shuffle__card"),
            flip = (src) => {
              src &&
                (shCard.classList.remove("is-flip"),
                shCard.offsetWidth,
                shCard.classList.add("is-flip"),
                setTimeout(() => {
                  shImg.src = src;
                }, 100));
            },
            t0 = Date.now();
          let list = null;
          try {
            list = await Promise.race([load(), wait(2e4).then(() => null)]);
          } catch {
            list = null;
          }
          (list &&
            list.length &&
            ((DB = list),
            (li[0].querySelector("span").textContent =
              `${list.length} rakt\xE1ron l\xE9v\u0151 j\xE1t\xE9k \xE1tn\xE9zve`)),
            li[0].classList.add("is-done"),
            (R = DB && DB.length ? rank() : null));
          const pics = R ? R.list.map((x) => x.p.img).concat(DB.slice(0, 12).map((p) => p.img)) : fanImgs;
          if (
            (pics.slice(0, 4).forEach((src) => {
              const im = new Image();
              im.src = src;
            }),
            !RM)
          ) {
            const delays = [90, 90, 100, 110, 120, 140, 160, 190, 230, 280, 340];
            let j = 1;
            for (const dl of delays)
              (await wait(dl),
                flip(pics[j % pics.length]),
                j++,
                j === 4 && li[1].classList.add("is-done"),
                j === 8 && li[2].classList.add("is-done"));
          }
          (li[1].classList.add("is-done"),
            li[2].classList.add("is-done"),
            R && R.list[0] && flip(R.list[0].p.img),
            await wait(Math.max(0, (RM ? 300 : 2300) - (Date.now() - t0))),
            li[3].classList.add("is-done"),
            await wait(RM ? 0 : 420),
            (S.k = 0),
            showResult(0, !0));
        },
        whyText = (x) => {
          const a = S.a,
            p = x.p,
            d = p.d,
            name = p.name,
            cl = [];
          cl.push(a.zone === "nemtudom" ? VIBE_TXT[a.vibe] : ZONE_TXT[a.zone]);
          const pr = arr(a.prio)[0];
          (cl.push(pr ? PRIO_TXT[pr] : EXP_TXT[a.exp]),
            a.budget && a.budget !== "any" ? cl.push(BUD_TXT[a.budget]) : pr && a.exp && cl.push(EXP_TXT[a.exp]));
          let txt = "Azt mondtad, hogy " + joinHu(cl.filter(Boolean)) + ". ";
          x.miss.length
            ? (txt += `${art(name, !0)} <strong>${esc(name)}</strong> a kéréseid nagy részét hozza. `)
            : x.over
              ? (txt += `${art(name, !0)} <strong>${esc(name)}</strong> mindent tud, amit kértél, csak kicsit drágább. `)
            : x.inB && a.budget && a.budget !== "any"
              ? (txt += `${art(name, !0)} <strong>${esc(name)}</strong> pont ebbe a s\xE1vba esik. `)
              : (txt += `${art(name, !0)} <strong>${esc(name)}</strong> pont erre van kital\xE1lva. `);
          const keys = [];
          (x.why.forEach((k) => {
            TRAIT[k] && TRAIT[k][1](d) && !keys.includes(k) && keys.push(k);
          }),
            TRAITS.forEach((t) => {
              !keys.includes(t[0]) && t[1](d) && !["strong", "simple", "beginner"].includes(t[0]) && keys.push(t[0]);
            }));
          const skip = ["beginner", "strong"].concat(a.exp === "elso" ? ["simple"] : []),
            sent = keys
              .filter((k) => !skip.includes(k))
              .slice(0, 2)
              .map((k) => TRAIT[k][2]);
          return (
            sent.length && (txt += sent.map((s) => s + ".").join(" ") + " "),
            a.exp === "elso"
              ? (txt += d.complex
                  ? "Van rajta p\xE1r gomb, de \xF6t perc alatt \xF6sszebar\xE1tkoztok."
                  : "\xC9s kezd\u0151k\xE9nt sem olyan, mintha egy rep\xFCl\u0151g\xE9pet pr\xF3b\xE1ln\xE1l beind\xEDtani.")
              : a.exp === "volt"
                ? (txt += "Pont annyi \xFAjdons\xE1g, amennyi m\xE9g j\xF3lesik.")
                : a.exp === "fiok" && (txt += "Gyan\xEDtjuk, hogy a gy\u0171jtem\xE9nyedben is \xFAj szintet hoz."),
            { html: txt.trim(), keys }
          );
        },
        chipsFor = (x, keys) => {
          const d = x.p.d,
            out = [],
            push = (k) => {
              const t = TRAIT[k];
              t && t[1](d) && !out.some((o2) => o2[3] === t[3]) && out.push(t);
            };
          return (
            keys.forEach(push),
            S.a.exp === "elso" && push("beginner"),
            arr(S.a.prio).forEach((k) =>
              push(
                {
                  kicsi: "mini",
                  eros: "strong",
                  egyszeru: "simple",
                  viz: "water",
                  app: d.app ? "app" : "remote",
                  dolgat: "simple",
                }[k],
              ),
            ),
            out.slice(0, 4)
          );
        },
        burst = (host) => {
          if (RM) return;
          const colors = ["#5e3f4e", "#8a6476", "#f1c4d5", "#fdead6", "#8b6549", "#e9b8c9"];
          let h = "";
          for (let n = 0; n < 30; n++) {
            const ang = Math.random() * Math.PI * 2,
              rad = 110 + Math.random() * 190,
              sz = 6 + Math.random() * 9;
            h += `<i style="--dx:${Math.cos(ang) * rad}px;--dy:${Math.sin(ang) * rad - 40}px;--r:${Math.random() * 540 - 270}deg;--s:${sz}px;--c:${colors[n % colors.length]};--br:${n % 3 ? "50%" : "3px"};--dl:${Math.random() * 120}ms"></i>`;
          }
          host.innerHTML = h;
        },
        countUp = (el, to) => {
          if (RM) {
            el.textContent = to + "%";
            return;
          }
          const t0 = performance.now(),
            step = (t) => {
              const k = Math.min(1, (t - t0) / 1e3);
              ((el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))) + "%"),
                k < 1 && requestAnimationFrame(step));
            };
          requestAnimationFrame(step);
        },
        renderEnd = (empty) => {
          const z = zoneOf(S.a),
            coll = `${base}/collections/${FALLBACK[z] || "vibrator"}`;
          resultEl.innerHTML = `
        <div class="ccq-end">
          <p class="ccq-eyebrow">${empty ? "Hopp\xE1" : "Ennyi volt a toplist\xE1nk"}</p>
          <h2 tabindex="-1">${empty ? "Most nem tudtuk bet\xF6lteni a k\xEDn\xE1latot." : "Egyik sem az igazi? Semmi gond."}</h2>
          <p>${empty ? "Pr\xF3b\xE1ld \xFAjra egy pillanat m\xFAlva, vagy n\xE9zz k\xF6r\xFCl abban a kateg\xF3ri\xE1ban, ahol a te j\xE1t\xE9kaid laknak." : "N\xE9ha egy-egy v\xE1lasz m\xF3dos\xEDt\xE1sa eg\xE9szen m\xE1s ir\xE1nyba visz. Vagy b\xF6ng\xE9szd v\xE9gig a kateg\xF3ri\xE1t, ahol a hozz\xE1d ill\u0151 j\xE1t\xE9kok vannak."}</p>
          <div class="ccq-match__acts">
            <a class="ccq-btn ccq-btn--solid" href="${esc(coll)}">Kateg\xF3ria b\xF6ng\xE9sz\xE9se ${svg("arrowR")}</a>
            <button type="button" class="ccq-btn ccq-btn--ghost" data-ccq-edit>${empty ? "\xDAjrapr\xF3b\xE1lom" : "V\xE1laszaim m\xF3dos\xEDt\xE1sa"}</button>
          </div>
        </div>
        <div class="ccq-after"><div class="ccq-after__links"><button type="button" class="ccq-link" data-ccq-restart>${svg("redo")} \xDAjrakezdem</button></div></div>`;
          const h = resultEl.querySelector("h2");
          h && h.focus({ preventScroll: !0 });
        },
        showResult = (k, fresh) => {
          if (((S.phase = "result"), (S.k = k), save(), show("result"), !R || !R.list.length)) {
            (renderEnd(!0), scrollTop());
            return;
          }
          if (k >= R.list.length) {
            (renderEnd(!1), scrollTop());
            return;
          }
          const x = R.list[k],
            p = x.p,
            pct = Math.min(
              Math.round(clamp(56 + (43 * Math.max(0, x.s)) / Math.max(1, R.max), 58, 99)),
              99 - k * 3,
              x.miss.length ? 90 - 8 * x.miss.length : 99,
              x.over ? 92 : 99,
            ),
            why = whyText(x),
            chips = chipsFor(x, why.keys),
            head = HEADS[Math.min(k, HEADS.length - 1)],
            canAdd = cfg.addToCart && p.n === 1 && p.v;
          let note = "";
          if (x.over && !x.miss.length)
            note = `<p class="ccq-match__note ccq-match__note--up">${svg("check")}<span><b>Mindent tud, amit kértél.</b> A keretedbe ilyen most nem fér bele, ez ${esc(money(x.over))}-tal drágább a felső határnál.</span></p>`;
          else if (x.miss.length)
            note = `<div class="ccq-match__note ccq-match__note--miss"><p>${x.over ? esc(money(x.over)) + "-tal drágább a keretednél, és a kéréseid közül ezt nem tudja" : S.a.budget && S.a.budget !== "any" ? (x.under ? "Olcsóbb a keretednél, de a kéréseid közül ezt nem tudja" : "Belefér a keretedbe, de a kéréseid közül ezt nem tudja") : "A kéréseid közül ezt nem tudja"}</p><ul>${x.miss.map((m) => `<li>${svg("x")}<span>${esc(m)}</span></li>`).join("")}</ul></div>`;
          else if (x.under)
            note = `<p class="ccq-match__note ccq-match__note--up">${svg("check")}<span><b>Mindent tud, amit kértél,</b> és ${esc(money(x.under))}-tal olcsóbb is a keretednél.</span></p>`;
          const lead =
            k === 0 && R.mode !== "exact"
              ? `<p class="ccq-result__lead">${
                  R.mode === "partial"
                    ? "Olyan játék, ami mindent tud, amit kértél, most nincs raktáron. Ezek állnak hozzá a legközelebb, és mindegyiknél leírjuk, mit nem tud."
                    : R.mode === "far"
                      ? "A keretedben most nincs raktáron hozzád illő játék, és a közelében sem. Ezek a legközelebbiek árban."
                      : "A keretedben most nincs raktáron olyan, ami mindent tud, amit kértél. Ezért kétféle utat mutatunk. Ami mindent tud, de kicsit drágább, és ami belefér, de valamit nem tud. Mindegyiknél leírjuk, melyik melyik."
                }</p>`
              : "";
          resultEl.innerHTML = `
        <div class="ccq-result__head">
          <p class="ccq-eyebrow"><span class="ccq-dot" aria-hidden="true"></span>${esc(k === 0 && R.mode !== "exact" ? "Őszinte találat" : head[0])}</p>
          <h2 class="ccq-result__title" tabindex="-1">${k === 0 && R.mode !== "exact" ? "Pontos találat most <em>nincs.</em>" : head[1]}</h2>
          ${lead}
        </div>
        <div class="ccq-match-wrap">
          <article class="ccq-match${fresh || k ? " is-new" : ""}" data-ccq-match aria-label="${esc(p.t)}">
            <div class="ccq-match__media">
              <span class="ccq-badge">${svg("heart")}<b data-ccq-pct>0%</b>&nbsp;egyez\xE9s</span>
              ${k ? `<span class="ccq-rank">${k + 1}. jel\xF6lt</span>` : ""}
              <span class="ccq-sw ccq-sw--yes" aria-hidden="true">Akarom</span>
              <span class="ccq-sw ccq-sw--nope" aria-hidden="true">Nem \xE9rzem</span>
              <img class="ccq-match__img" src="${esc(p.img)}" alt="${esc(p.t)}" width="720" height="720" draggable="false">
              <span class="ccq-burst" data-ccq-burst aria-hidden="true"></span>
            </div>
            <div class="ccq-match__body">
              <p class="ccq-match__brand">${esc(p.b)}</p>
              <h3 class="ccq-match__name">${esc(p.t)}</h3>
              <p class="ccq-match__why">${why.html}</p>
              ${note}
              ${chips.length ? `<ul class="ccq-chips" aria-label="Ami\xE9rt illik hozz\xE1d">${chips.map((c, n) => `<li style="--i:${n}">${svg("check")}${esc(c[3])}</li>`).join("")}</ul>` : ""}
              <div class="ccq-price">
                <span class="ccq-price__now">${esc(money(p.price))}</span>
                ${p.cmp > p.price ? `<s>${esc(money(p.cmp))}</s>` : ""}
                <span class="ccq-price__stock">Rakt\xE1ron</span>
              </div>
              <div class="ccq-match__acts">
                <a class="ccq-btn ccq-btn--solid ccq-btn--xl" href="${esc(p.u)}" data-ccq-go>Megn\xE9zem ${svg("arrowR")}</a>
                ${canAdd ? `<button type="button" class="ccq-btn ccq-btn--ghost ccq-btn--xl" data-ccq-add>${svg("cart")}<span>Kos\xE1rba teszem</span></button>` : ""}
              </div>
              <p class="ccq-match__msg" role="status" data-ccq-msg></p>
            </div>
          </article>
        </div>
        <div class="ccq-after">
          <button type="button" class="ccq-next" data-ccq-nope>${svg("arrowL")}<span>Nem \xE9rzem. Mutass m\xE1sikat.</span></button>
          <p class="ccq-hint">vagy h\xFAzd balra a k\xE1rty\xE1t</p>
          <div class="ccq-after__links">
            <button type="button" class="ccq-link" data-ccq-restart>${svg("redo")} \xDAjrakezdem</button>
            <button type="button" class="ccq-link" data-ccq-edit>${svg("edit")} V\xE1laszaim m\xF3dos\xEDt\xE1sa</button>
          </div>
        </div>`;
          const match = resultEl.querySelector("[data-ccq-match]");
          (countUp(resultEl.querySelector("[data-ccq-pct]"), pct),
            k === 0 && fresh && burst(resultEl.querySelector("[data-ccq-burst]")),
            !fresh &&
              k &&
              !RM &&
              match.animate &&
              match.animate(
                [
                  { transform: "translateY(26px) scale(.95)", opacity: 0 },
                  { transform: "none", opacity: 1 },
                ],
                { duration: 620, easing: "cubic-bezier(.22,1,.36,1)" },
              ),
            bindSwipe(match, p));
          const h = resultEl.querySelector(".ccq-result__title");
          (h && h.focus({ preventScroll: !0 }),
            scrollTop(),
            track("cc_quiz_result", {
              rank: k + 1,
              product_id: p.id,
              handle: p.h,
              score: x.s,
              match: pct,
              relaxed: R.relaxed,
              mode: R.mode,
              misses: x.miss.length,
              over_budget: x.over ? Math.round(x.over / 100) : 0,
            }));
        },
        nope = () => {
          const match = resultEl.querySelector("[data-ccq-match]");
          track("cc_quiz_next", { from_rank: S.k + 1 });
          const go = () => showResult(S.k + 1, !1);
          if (!match || RM || !match.animate) {
            go();
            return;
          }
          const cur = match.style.transform || "none";
          match.animate(
            [
              { transform: cur, opacity: 1 },
              { transform: "translate(-125%, 4%) rotate(-18deg)", opacity: 0 },
            ],
            { duration: 460, easing: "cubic-bezier(.55,0,.7,.2)", fill: "forwards" },
          ).onfinish = go;
        },
        bindSwipe = (card, p) => {
          if (!card || !window.PointerEvent) return;
          const yes = card.querySelector(".ccq-sw--yes"),
            no = card.querySelector(".ccq-sw--nope");
          let sx = 0,
            sy = 0,
            dx = 0,
            on = !1,
            locked = !1,
            id = null;
          const reset = () => {
            ((card.style.transition = "transform .45s cubic-bezier(.34,1.56,.64,1)"),
              (card.style.transform = ""),
              (yes.style.opacity = no.style.opacity = 0),
              setTimeout(() => {
                card.style.transition = "";
              }, 460));
          };
          (card.addEventListener("pointerdown", (e) => {
            e.button !== 0 ||
              e.target.closest("a,button") ||
              ((on = !0), (locked = !1), (dx = 0), (sx = e.clientX), (sy = e.clientY), (id = e.pointerId));
          }),
            card.addEventListener("pointermove", (e) => {
              if (!on || e.pointerId !== id) return;
              const mx = e.clientX - sx,
                my = e.clientY - sy;
              if (!locked) {
                if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
                if (Math.abs(my) > Math.abs(mx)) {
                  on = !1;
                  return;
                }
                locked = !0;
                try {
                  card.setPointerCapture(id);
                } catch {}
              }
              ((dx = mx),
                (card.style.transform = `translateX(${dx}px) rotate(${dx / 22}deg)`),
                (yes.style.opacity = clamp(dx / 110, 0, 1)),
                (no.style.opacity = clamp(-dx / 110, 0, 1)));
            }));
          const end = () => {
            on &&
              ((on = !1),
              locked &&
                (setTimeout(() => {
                  ((locked = !1), (dx = 0));
                }, 0),
                dx < -110
                  ? nope()
                  : dx > 110
                    ? (track("cc_quiz_click", { handle: p.h, via: "swipe" }),
                      (card.style.transition = "transform .4s ease, opacity .4s ease"),
                      (card.style.transform = "translate(125%, 4%) rotate(18deg)"),
                      (card.style.opacity = "0"),
                      setTimeout(() => {
                        window.location.href = p.u;
                      }, 300))
                    : reset()));
          };
          (card.addEventListener("pointerup", end),
            card.addEventListener("pointercancel", () => {
              on && ((on = !1), reset());
            }),
            card.addEventListener(
              "click",
              (e) => {
                locked && Math.abs(dx) > 8 && (e.preventDefault(), e.stopPropagation());
              },
              !0,
            ));
        },
        addToCart = async (btn) => {
          const x = R && R.list[S.k];
          if (!x || btn.disabled) return;
          const msg = resultEl.querySelector("[data-ccq-msg]"),
            label = btn.querySelector("span");
          ((btn.disabled = !0),
            btn.classList.add("is-busy"),
            (label.textContent = "Kos\xE1rba teszem\u2026"),
            (msg.textContent = ""));
          try {
            const fd = new FormData();
            (fd.append("id", x.p.v),
              fd.append("quantity", "1"),
              fd.append("properties[_cc_quiz]", String(S.k + 1)),
              fd.append("sections", "cart-drawer,header-cart-status"),
              fd.append("sections_url", window.location.pathname));
            const res = await fetch(String(cfg.cartAdd || "/cart/add").replace(/\.js$/, "") + ".js", {
                method: "POST",
                headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
                body: fd,
              }),
              data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || "add");
            const df = document.querySelector("ecx-cart-drwr-frm");
            df && typeof df.renderContents == "function" && data.sections && df.renderContents(data);
            const hs = document.querySelector("#headerCartStatus");
            if (hs && data.sections && data.sections["header-cart-status"]) {
              const sec = new DOMParser()
                .parseFromString(data.sections["header-cart-status"], "text/html")
                .querySelector(".shopify-section");
              hs.innerHTML = sec ? sec.innerHTML : data.sections["header-cart-status"];
            }
            (track("cc_quiz_add", { handle: x.p.h, rank: S.k + 1 }),
              btn.classList.remove("is-busy"),
              (label.textContent = "Kos\xE1rban"),
              (btn.querySelector("svg").outerHTML = svg("check")));
            const drawer = document.querySelector("ecx-cart-drwr");
            drawer ? drawer.setAttribute("open", "") : (window.location.href = cfg.cart || "/cart");
          } catch {
            ((btn.disabled = !1),
              btn.classList.remove("is-busy"),
              (label.textContent = "Kos\xE1rba teszem"),
              (msg.textContent =
                "Ezt most nem siker\xFClt a kos\xE1rba tenni. Pr\xF3b\xE1ld meg \xFAjra, vagy nyisd meg a term\xE9koldalt."));
          }
        },
        start = (keep) => {
          (keep || (S = { a: {}, i: 0, phase: "play", k: 0 }),
            (S.phase = "play"),
            (S.i = 0),
            (R = null),
            (poolShown = 0),
            (deck.innerHTML = ""),
            (progressEl.innerHTML = ""),
            show("play"),
            load(),
            renderQ(1),
            track("cc_quiz_start", { edit: !!keep }));
        };
      (root.addEventListener("click", (e) => {
        const t = e.target;
        if (t.closest("[data-ccq-start]")) {
          start(!1);
          return;
        }
        const opt = t.closest(".ccq-opt");
        if (opt && deck.contains(opt)) {
          (ripple(opt, e), choose(opt));
          return;
        }
        if (t.closest("[data-ccq-back]")) {
          back();
          return;
        }
        const nx = t.closest("[data-ccq-next]");
        if (nx) {
          if (busy) return;
          const qid = nx.closest(".ccq-card").dataset.q;
          arr(S.a[qid]).length
            ? advance("\xC9rtj\xFCk. Ez sokat seg\xEDt a d\xF6nt\xE9sben.")
            : ((S.a[qid] = []), advance("Rendben, akkor a t\xF6bbi v\xE1laszod d\xF6nt."));
          return;
        }
        if (t.closest("[data-ccq-nope]")) {
          nope();
          return;
        }
        if (t.closest("[data-ccq-restart]")) {
          (store.clear(), start(!1));
          return;
        }
        if (t.closest("[data-ccq-edit]")) {
          start(!0);
          return;
        }
        if (t.closest("[data-ccq-add]")) {
          addToCart(t.closest("[data-ccq-add]"));
          return;
        }
        t.closest("[data-ccq-go]") &&
          R &&
          R.list[S.k] &&
          track("cc_quiz_click", { handle: R.list[S.k].p.h, rank: S.k + 1, via: "button" });
      }),
        root.addEventListener("keydown", (e) => {
          if (!(e.altKey || e.ctrlKey || e.metaKey))
            if (S.phase === "play" && !screens.play.hidden) {
              const card = deck.querySelector(".ccq-card:last-child");
              if (!card) return;
              if (/^[1-9]$/.test(e.key)) {
                const b = card.querySelectorAll(".ccq-opt")[Number(e.key) - 1];
                b && (e.preventDefault(), b.focus({ preventScroll: !0 }), choose(b));
              } else
                e.key === "Backspace" && !/INPUT|TEXTAREA/.test(document.activeElement.tagName)
                  ? (e.preventDefault(), back())
                  : e.key === "Enter" &&
                    QS[card.dataset.q].multi &&
                    arr(S.a[card.dataset.q]).length &&
                    !e.target.closest(".ccq-opt") &&
                    (e.preventDefault(), advance(""));
            } else
              S.phase === "result" &&
                e.key === "ArrowLeft" &&
                !e.target.closest("a,button") &&
                (e.preventDefault(), nope());
        }),
        (window.requestIdleCallback || ((fn) => setTimeout(fn, 400)))(() => load()));
      root.__ccqLab = { load, rank: (a) => (DB && DB.length ? rank(a) : null), reqs: REQS, budget: BUDGET };
      const saved = store.get();
      !(window.Shopify && Shopify.designMode) &&
        saved &&
        saved.a &&
        Date.now() - (saved.at || 0) < 2700 * 1e3 &&
        saved.phase !== "intro" &&
        ((S = { a: saved.a, i: saved.i || 0, phase: saved.phase, k: saved.k || 0 }),
        saved.phase === "result" || saved.phase === "load"
          ? (show("load"),
            ($("[data-ccq-steps]").innerHTML = ""),
            load()
              .then((l) => {
                ((DB = l), (R = rank()), showResult(Math.min(S.k, R.list.length), !1));
              })
              .catch(() => {
                ((R = null), showResult(0, !1));
              }))
          : (show("play"), load(), renderQ(1, "Ott folytatjuk, ahol abbahagytad.")));
    },
    boot = () =>
      document.querySelectorAll("[data-ccq]").forEach((r) => {
        r.__ccq || ((r.__ccq = !0), init(r));
      });
  (document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", boot) : boot(),
    document.addEventListener("shopify:section:load", boot));
})();
//# sourceMappingURL=/cdn/shop/t/9/assets/cc-quiz.js.map?v=127816615437329352861790921043
